/** @jsxImportSource @emotion/react */
/**
 * Универсальный компонент для ввода значения атрибута
 * Поддерживает разные типы данных: number, decimal, text, boolean, date, datetime
 */
import React from 'react';
import { Input, InputNumber, Switch, DatePicker } from 'antd';
import { commonStyles } from '../../styles/commonStyles';

interface AttributeInputProps {
  dataType: 'number' | 'integer' | 'decimal' | 'float' | 'text' | 'boolean' | 'date' | 'datetime';
  value?: any;
  onChange?: (value: any) => void;
}

export const AttributeInput: React.FC<AttributeInputProps> = ({
  dataType,
  value,
  onChange,
}) => {
  switch (dataType) {
    case 'number':
    case 'integer':
      return <InputNumber css={commonStyles.fullWidth} value={value} onChange={onChange} />;
    case 'decimal':
    case 'float':
      return <InputNumber css={commonStyles.fullWidth} step={0.01} value={value} onChange={onChange} />;
    case 'text':
      return <Input value={value} onChange={(e) => onChange?.(e.target.value)} />;
    case 'boolean':
      return <Switch checked={value} onChange={onChange} />;
    case 'date':
      return <DatePicker css={commonStyles.fullWidth} format="DD.MM.YYYY" value={value} onChange={onChange} />;
    case 'datetime':
      return <DatePicker showTime css={commonStyles.fullWidth} format="DD.MM.YYYY HH:mm" value={value} onChange={onChange} />;
    default:
      return <Input value={value} onChange={(e) => onChange?.(e.target.value)} />;
  }
};

export default AttributeInput;
